// extracted by mini-css-extract-plugin
export var calendarView = "_64-0";